import HeaderContainer from "./components/tiles-prayer-header/TilesPrayerHeader";
import TilesPrayerContent from "./components/tiles-prayer-content/TilesPrayerContainer";

import { ITimedEvent } from "@/helpers/format-prayer-tide";

import "./style.scss";

type TilesPrayerContainerProps = {
	title: string;
	icon: React.ReactElement;
	info: string;
	data: ITimedEvent[];
	showCurrentType: boolean;
};

export const TilesPrayerContainer = ({
	showCurrentType,
	title,
	icon,
	info,
	data,
}: TilesPrayerContainerProps) => {
	return (
		<div className="tiles-prayer-container">
			<HeaderContainer title={title} icon={icon} info={info} />
			<TilesPrayerContent data={data} showCurrentType={showCurrentType} />
		</div>
	);
};

export default TilesPrayerContainer;
